import React from 'react';
import Reflux from 'reflux';
import {Button, Form, Row, Col, Modal, Input, message, Select, DatePicker} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice} from 'Utils';
import {getPro, create, list2, getSubStoreList, detail, getXiaFu} from '../../service/thingsOrder';
import './corder.css';
import moment from 'moment';

const confirm = Modal.confirm;

class ThingsOrderAddCopy extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            button_limits_end: {},
            opts: ['复制销售单'],
            subDisabled: false,
            key: 0,
            visible: false,
            addRows: [],
            addTotal: 1,
            selectedRowsAll: {},
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
            amount: 0, //总额
            actualAmount: 0, //实收金额
            name: '',
            code: '',
            showPrice: '',
            caozuoyuan: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            ids: [],
            discountRate: 100, //订单整体折扣率
            disActualAmount: 0, //整单折扣后实收金额
            storeId: '',
            customerId: '',
            sortName: '',
            orderType: '',
            remarkData: '',
            remark: '',
            getMoneyTypeData: '',
            orderDate: '',
            customerInDate: '',
            price: '',
            list2Data: [],
            subStoreList: [],
            count: '',
            priceRate: '',
            addSearchObj: {
                s: 10,
                p: 1
            },
            submitRows: [],
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}')
        };
    };


    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    goBack() {
        hashHistory.goBack();
    }

    /*选择外层列表*/
    onOutsideSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    }
    /*外层翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.initData();
        });
    }
    /*选择物料弹窗*/
    searchHandler = () => {
        if (!this.state.storeId || this.state.storeId == '') {
            openNotice('warning', '请先选择子库存', '');
            return
        }
        // this.getAddArray();
        this.setState({visible: true, showPrice: '', price: ''});
    }
    deletedFn = () => {
        const {submitRows, selectedRowKeysOutside} = this.state;
        if (selectedRowKeysOutside.length == 0) {
            openNotice('warning', '请选择删除数据', '');
            return;
        }
        const arr = submitRows.filter(item => !selectedRowKeysOutside.includes(item.id));
        const selected = [];
        arr.forEach(item => {
            selected.push(item.id)
        });
        this.setState({
            submitRows: arr,
            selectedRowsAllKeys: [...selected],
        }, () => {
            this.confirmAmount();
        });
    }
    /*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        const {selectedRowsAll, addSearchObj} = this.state;
        selectedRowsAll[addSearchObj.p] = selectedRows;
        this.setState({
            selectedRowsAll: selectedRowsAll,
            selectedRowKeys: selectedRowKeys
        });
    };
    /*选择物料列表翻页*/
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, () => {
            this.getAddArray();
        });
    };

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    };
    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };
    /*选择物料列表数据(点击搜索)*/
    getAddArray = () => {
        if (this.state.code == '' && this.state.name == '') {
            openNotice('warning', '请先输入需要搜索的物料', '');
            return
        }
        const searchObj = {
            code: this.state.code,
            name: this.state.name,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s,
            substoreId: this.state.storeId || '',
        };
        getPro(searchObj).then(result => {
            if (result.status && result.code == 200) {
                const data = result.data || [];
                this.setState({
                    addRows: data,
                    addTotal: result.total
                });
            } else {
                message.error(result.message);
            }
        })
    };
    //数量
    viewCountChange = (record, e) => {

        record.count = e.target.value;
        if (!record.price) {
            record.price = 0;
        }
        this.confirmAmount(record.price, record.count);
        this.setState({count: e.target.value, showPrice: record.showPrice});
    };
    changePrice = (record, e) => {
        /*if (e.target.value > record.showPrice || e.target.value < 0) {
            return
        }*/
        record.price = e.target.value;
        if (!record.count) {
            record.count = 0;
        }
        record.priceRate = Math.round((1 - (record.price / record.showPrice)) * 10000) / 100;
        this.setState({priceRate: record.priceRate, price: record.price}, () => {
            this.confirmAmount(record.price, record.count);
        });
    };

    changLineRemark = (record, e) => {
        record.remark = e.target.value;
        this.setState({remark: record.remark});
    }

//下浮率
    priceRateFn = (record, e) => {
        /*if (e.target.value > 100 || e.target.value < 0) {
            return
        }*/
        record.priceRate = e.target.value;
        if (!record.count) {
            record.count = 0;
        }
        record.price = ((1 - (e.target.value / 100)) * record.showPrice).toFixed(2);
        // this.state.actualAmount = (this.state.actualAmount + this.state.count * (record.showPrice - record.price));
        this.setState({priceRate: e.target.value, price: record.price}, () => {
            this.confirmAmount(record.price, record.count);
        });
    }

//计算金额
    confirmAmount() {
        let submitRows = this.state.submitRows;
        let amount = 0;
        let actualAmount = 0;
        submitRows.map(item => {
            amount += (item.showPrice || 0) * (item.count || 0);
            actualAmount += (item.price || 0) * (item.count || 0);
            this.setState({
                amount,
                actualAmount,
                disActualAmount: (actualAmount * this.state.discountRate / 100).toFixed(2)
            });
        })
    }

    caozuoChange = (e) => {
        this.setState({caozuoyuan: e.target.value});
    }
//整体折扣率
    countChange = (e) => {
        /*if (e.target.value > 100) {
            return;
        }*/
        this.setState({
            discountRate: e.target.value,
            disActualAmount: (this.state.actualAmount * e.target.value / 100).toFixed(2)
        });
    }
    disActualAmountChange = (e) => {
        /*if (e.target.value > this.state.actualAmount) {
            return;
        }*/
        this.setState({
            disActualAmount: e.target.value,
            discountRate: (e.target.value / this.state.actualAmount * 100).toFixed(2)
        });
    }
    remarkChange = (e) => {
        this.setState({remarkData: e.target.value});
    }
//子库存id
    storeChange = (value) => {
        const self = this;
        if (this.state.storeId && this.state.storeId != '') {
            confirm({
                content: '切换子库存将重置订单商品,确定吗?',
                onOk() {
                    self.setState({
                        submitRows: [],
                        amount: 0,
                        actualAmount: 0,
                        // storageLocal: value.key
                    });
                },
                onCancel() {
                    return
                }
            })
        }
        this.setState({storeId: value});
    }
//客户id
    customerChange = (value) => {
        const self = this;
        if (this.state.customerId && this.state.customerId != '') {
            confirm({
                content: '切换客户名称将重置订单商品,确定吗?',
                onOk() {
                    self.setState({
                        submitRows: [],
                        amount: 0,
                        actualAmount: 0,
                        // storageLocal: value.key
                    });
                },
                onCancel() {
                    return
                }
            })
        }
        this.setState({customerId: value});
    }
    /*客户缩写*/
    shortNameChange = (value) => {
        const self = this;
        if (this.state.sortName && this.state.sortName != '') {

            self.setState({
                submitRows: [],
                amount: 0,
                actualAmount: 0,

            });
            // },
            /*onCancel() {
                return
            }*/
            // })
        }
        this.setState({sortName: value});
    }
//订单类型
    orderTypeChange = (value) => {
        const self = this;

        if (this.state.customerId && this.state.customerId != '') {
            confirm({
                content: '切换订单类型将重置客户名称、客户缩写、订单商品,确定吗?',
                onOk() {
                    self.setState({
                        submitRows: [],
                        amount: 0,
                        actualAmount: 0,
                        // storageLocal: value.key
                    });
                    //这里是通过订单类型筛选客户名称下拉框选项的逻辑判断
                    if (value === '1') {
                        self.getList2({p: 1, s: 1000});
                    }
                    if (value === '2') {
                        self.getList2({cusType: 'SALES_CUS', p: 1, s: 1000});
                    }
                    if (value === '3') {
                        self.getList2({p: 1, s: 1000});
                    }
                    self.setState({orderType: value, customerId: '', sortName: ''});
                },
                onCancel() {
                    return
                }
            })
        } else {
            if (value === '1') {
                self.getList2({p: 1, s: 1000});
            }
            if (value === '2') {
                self.getList2({cusType: 'SALES_CUS', p: 1, s: 1000});
            }
            if (value === '3') {
                self.getList2({p: 1, s: 1000});
            }
            self.setState({orderType: value, customerId: '', sortName: ''});
        }
    }
    getMoneyType = (value) => {
        this.setState({getMoneyTypeData: value});
    }
    dateOnChange = (date, dateString) => {
        if (date) {
            this.setState({orderDate: dateString});
        }
    }
    /*点击保存提交数据*/
    createHandler = () => {
        var self = this;
        self.setState({subDisabled: true});
        let arr = [];
        let id = this.props.params.id;
        const len = this.state.submitRows.length;
        console.log(this.state.submitRows);
        if (this.state.getMoneyTypeData == '') {
            openNotice('error', '请选择付款方式', '');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.orderType == '') {
            openNotice('error', '请选择订单类型', '');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.customerId == '') {
            openNotice('error', '请选择客户名称', '');
            self.setState({subDisabled: false});
            return;
        }
        if (len === 0) {
            openNotice('error', '请添加产品', '');
            self.setState({subDisabled: false});
            return;
        }
        this.state.submitRows.forEach(item => {
            arr.push({
                productId: (item.productId || item.id) + '',
                priceRate: item.priceRate + '',
                count: item.count + '',
                currentPrice : item.currentPrice + '',
                unitPrice: item.price,
                sumPrice: (item.showPrice * item.count) + '',
                productType: item.type || item.productType,
                remark: item.remark,
                unit: item.unit,
                originalPrice: item.originalPrice
            });
        });
        arr.reverse();
        const flag = arr.every(item => !!item.priceRate && !!item.count);
        if (!flag) {
            openNotice('error', '请输入下浮率和数量！');
            self.setState({subDisabled: false});
            return;
        }
        var createObj = {
            "amount": self.state.amount,
            "cusId": self.state.customerId,
            "sortName": self.state.sortName,
            "discountRate": self.state.discountRate,
            "operateName": self.state.caozuoyuan,
            "orderDate": moment(new Date()).format('YYYY-MM-DD HH:mm:SS '),
            "orderType": self.state.orderType,
            "disCountAmount": (self.state.amount - self.state.actualAmount),
            "payType": self.state.getMoneyTypeData,
            "productList": arr,
            "receivedAmount": self.state.actualAmount,
            "remark": self.state.remarkData,
            "storageId": this.state.storeId,
        };
        /*if (id) {
            createObj.id = id;
        }*/
        create(createObj).then(result => {
            console.log(result);
            if (result.status && result.code == 200) {
                openNotice('success', '保存成功', '');
                const data = result.data;
                console.log(result.data.code);
                // console.log(record.id);
                self.goView('thingsOrder/' + data.id);
            } else {
                openNotice('error', '保存失败', result.message || '');
                self.setState({subDisabled: false});
            }
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        this.getList2({p: 1, s: 1000});
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then((result) => { //获取子库存
            console.log(result);
            if (result && result.code == 200) {
                self.setState({subStoreList: result.data});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

    getList2(param) {
        list2(param).then((result) => { //获取客户管理
            if (result && result.code == 200) {
                this.setState({list2Data: result.data});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

//离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    };

    componentWillMount() {
        window.myTemp = 1;
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }
    ;

    componentDidMount() {
        let id = this.props.params.id;
        this.initData();
        if (id) {
            detail(id).then(res => {
                if (res.code === 200) {
                    const data = res.data || {};
                    (data.productList || []).forEach(item => {
                        item.showPrice = item.currentPrice;
                        item.price = item.unitPrice;
                    });
                    this.setState({
                        orderDate: data.orderDate,
                        orderType: data.orderType + '',
                        getMoneyTypeData: data.payType,
                        storeId: data.storageId ? (data.storageId + '') : '',
                        customerId: data.cusId + '',
                        sortName: data.cusShortname + '',
                        remarkData: data.remark,
                        discountRate: data.discountRate,
                        disActualAmount: (data.discountRate * data.discountRate / 100).toFixed(2),
                        submitRows: data.productList || []
                    }, () => {
                        this.confirmAmount();
                    });
                }
            });
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    handleOk = () => {
        const self = this;
        const {selectedRowsAll} = this.state;
        var arr = Object.values(selectedRowsAll).reduce((prev, current) => prev.concat(current), []);
        const selected = [];
        arr.forEach(item => {
            selected.push(item.id);
        });
        var arrNew = [...arr];
        for (let t = 0; t < arr.length; t++) {
            getXiaFu({
                "cusId": self.state.customerId,
                "proId": arrNew[t].id,
                "proType": arrNew[t].type
            }).then(res => {
                // debugger
                // console.log(arrNew);
                arrNew[t] = {
                    ...arr[t],
                    priceRate: res.data.priceRate,
                    price: (100 - res.data.priceRate) * arrNew[t].showPrice / 100,
                };
                self.setState({submitRows: [...this.state.submitRows, arrNew[t]]})
            })
        }
        self.setState({
            // submitRows: [...this.state.submitRows, ...arrNew],
            selectedRowsAllKeys: [...this.state.selectedRowsAllKeys, ...selected],
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
        });
        self.handleCancel()
    };
    handleCancel = () => {
        this.setState({
            name: '',
            code: '',
            visible: false
        });
    };

    goView(url) {
        hashHistory.push(url);
    }

    addSave(record) {
        const self = this;
        const {selectedRowsAllKeys, submitRows, selectedRowKeys, selectedRowsAll, searchObj} = this.state;
        if (selectedRowsAllKeys.includes(record.id)) {
            openNotice('warning', '商品已添加');
            return
        }
        const arr1 = selectedRowKeys.filter(item => item !== record.id);
        let arr2 = [];
        if (selectedRowsAll[searchObj.p]) {
            arr2 = selectedRowsAll[searchObj.p].filter(item => item.id !== record.id);
        }
        selectedRowsAll[searchObj.p] = arr2;
        //获取下浮
        let record1 = {...record};
        getXiaFu({
            "cusId": self.state.customerId,
            "proId": record.id,
            "proType": record.type
        }).then(res => {
            record1.priceRate = res.data.priceRate;
            record1.price = (100 - res.data.priceRate) * record.showPrice / 100;
        })
        this.setState({
            selectedRowKeys: [...arr1],
            selectedRowsAllKeys: [...selectedRowsAllKeys, record.id],
            selectedRowsAll: {...selectedRowsAll},
            submitRows: [...submitRows, record1]
        })
    }

    render() {
        var self = this;
        const {
            opts, key, total, searchObj, selectedRowKeys, showPrice, price,
            selectedRowKeysOutside, count, list2Data, subStoreList, visible, storeId, customerId,
            actualAmount, amount, orderDate, discountRate, remarkData, caozuoyuan, orderType, getMoneyTypeData,
            addRows, addTotal, addSearchObj, button_limits_end, remark, disActualAmount, sortName
        } = this.state;
        // const {getFieldDecorator} = this.props.form;

        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code'
                },
                {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: '200px'
                },
                {
                    title: '物料类别',
                    dataIndex: 'proType'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '现有量',
                    dataIndex: 'currentNum'
                },
                {
                    title: '历史价',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '面价',
                    dataIndex: 'showPrice'
                },
                {
                    title: '下浮(%)',
                    dataIndex: 'priceRate',
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                },
                {
                    title: '销售金额',
                    dataIndex: 'discountMoney',
                    render: (text, record, index) => {
                        return <div>{(record.unitPrice * record.count).toFixed(4) || 0}</div>
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                },

            ],
            rows: this.state.submitRows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: self.onOutsideSelectChange}
        };
        const addProps = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 100,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: '100px'
                }, {
                    title: '供应商',
                    dataIndex: 'supplier',

                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',

                }, {
                    title: '面价',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>
                }, {
                    title: '历史价格',
                    dataIndex: 'originalPrice',

                }, {
                    title: '备注',
                    dataIndex: 'remark',

                }, {
                    title: '创建时间',
                    dataIndex: 'createdDate',
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                }
            ],
            rows: addRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: record => ({
                    disabled: this.state.selectedRowsAllKeys.includes(record.id)
                })
            }*/
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button style={{marginLeft: 10}} onClick={this.createHandler}>复制订单</Button>
                <Button onClick={this.goBack}>取消</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Form layout="horizontal">
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">订单日期：</label>
                            <DatePicker style={{width: 220}} onChange={this.dateOnChange}
                                        showTime
                                        disabled
                                        format="YYYY-MM-DD HH:mm:ss"
                                        value={orderDate ? moment(new Date(orderDate)) : moment(new Date())}/>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">订单类型：</label>
                            <Select style={{width: 220}} value={orderType}
                                    disabled
                                    onChange={this.orderTypeChange}
                            >
                                <Select.Option value='1'>销售出库</Select.Option>
                                <Select.Option value='2'>零售单</Select.Option>
                                <Select.Option value='3'>退货单</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">收款方式：</label>
                            <Select style={{width: 220}}
                                    disabled
                                    value={getMoneyTypeData}
                                    onChange={this.getMoneyType}
                            >
                                <Select.Option value='现金'>现金</Select.Option>
                                <Select.Option value='欠款'>欠款</Select.Option>
                                <Select.Option value='代收'>代收</Select.Option>
                                <Select.Option value='月结'>月结</Select.Option>
                            </Select>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">子库存：</label>
                            <Select style={{width: 220}}
                                    disabled
                                    value={storeId}
                                    onChange={this.storeChange}
                            >
                                {
                                    subStoreList.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.subStoreName}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">客户名称：</label>
                            <Select
                                showSearch
                                optionFilterProp="children"
                                disabled
                                value={customerId + ''}
                                style={{width: 220}}
                                onSelect={this.customerChange.bind(this)}
                                onChange={this.shortNameChange}
                            >
                                {
                                    list2Data.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.name}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">客户缩写：</label>
                            <Select
                                showSearch
                                optionFilterProp="children"
                                disabled
                                value={sortName + ''}
                                style={{width: 220}}
                                onSelect={this.shortNameChange.bind(this)}
                                onChange={this.customerChange}
                            >
                                {
                                    list2Data.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.sortName}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label>操作员：</label>
                            <Input value={caozuoyuan} style={{width: 220}} disabled onChange={this.caozuoChange}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label>备注：</label>
                            <Input value={remarkData} style={{width: 150}} disabled onChange={this.remarkChange}/>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        {button_limits_end.thingsOrder_add_05 &&
                        <Button disabled onClick={this.searchHandler}>新增</Button>}
                        {button_limits_end.thingsOrder_add_06 &&
                        <Button onClick={this.deletedFn} disabled style={{marginLeft: 10}}>删除</Button>}
                    </div>
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">面价总额：￥{amount.toFixed(2)}</span></p>
                        <p><span className="right">优惠金额：￥{(amount - actualAmount).toFixed(2)}</span></p>
                        <p><span className="right">销售总额：￥{actualAmount.toFixed(2)}</span></p>
                        <p><span className="right">订单整体折扣：%<Input value={discountRate} disabled style={{width: 100}}
                                                                  type='number'
                                                                  onChange={this.countChange}/></span></p>
                        <p><span className="right">实收总额：￥<Input
                            value={disActualAmount}
                            style={{width: 100}}
                            type='number'
                            disabled
                            onChange={this.disActualAmountChange}/></span></p>
                    </div>
                </div>

            </div>

            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称：</label><Input style={{width: 200}} value={this.state.name}
                                                                     onChange={this.nameChange}/></Col>
                            <Col span={8}><label>物料编码：</label><Input style={{width: 200}} value={this.state.code}
                                                                     onChange={this.codeChange}/></Col>
                            <Col span={8}><Button onClick={this.getAddArray}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                </div>
            </Modal>

        </div>
    }
}

export default withRouter(ThingsOrderAddCopy);


// WEBPACK FOOTER //
// ./src/routes/thingsOrder/addCopy.js